// Re-initialize tooltips re-created by Tablesaw stack mode (rebuilds cell content via innerHTML
// and clones header cells into labels – classes survive, listeners don't)
document.addEventListener("tablesawcreate", function (event) {
  setTimeout(function () {
    if (typeof tooltipControl !== "function") return;
    event.target
      .querySelectorAll(
        ".tablesaw-cell-content .tooltip.no-css-hover, .tablesaw-cell-label .tooltip.no-css-hover",
      )
      .forEach(function (tooltip) {
        tooltip.classList.remove("no-css-hover");
      });
    tooltipControl();
  }, 0);
});
